{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-420000",
  "sheetId": "StatementOfComprehensiveIncomeBeforeTax",
  "label": "[420000] Statement of comprehensive income, before tax",
  "description": "Statement of comprehensive income showing other comprehensive income items before tax",
  "controls": [
    {
      "qname": "ssmt:StatementOfComprehensiveIncomeHeader",
      "label": "STATEMENT OF COMPREHENSIVE INCOME",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 1
      }
    },
    {
      "qname": "ssmt:ProfitForTheYearCI",
      "label": "Profit for the year",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Should match profit from P&L statement"
      }
    },
    {
      "qname": "ssmt:OtherComprehensiveIncomeHeader",
      "label": "OTHER COMPREHENSIVE INCOME",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt:ItemsNotReclassifiedHeader",
      "label": "Items that will not be reclassified to profit or loss:",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ssmt:RemeasurementOfDefinedBenefitPlansBeforeTax",
      "label": "Remeasurement of defined benefit plans (before tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:FairValueChangeOnEquityInvestmentsFVOCIBeforeTax",
      "label": "Fair value changes on equity investments at FVOCI (before tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:RevaluationSurplusOnPropertyPlantAndEquipmentBeforeTax",
      "label": "Revaluation surplus on property, plant and equipment (before tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:ShareOfOCIOfAssociatesNotReclassifiedBeforeTax",
      "label": "Share of OCI of associates and joint ventures - not reclassified (before tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:TaxRelatingToItemsNotReclassified",
      "label": "Tax relating to items that will not be reclassified",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:TotalItemsNotReclassifiedNetOfTax",
      "label": "Total items not reclassified (net of tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:ItemsMayBeReclassifiedHeader",
      "label": "Items that may be reclassified subsequently to profit or loss:",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ssmt:ExchangeDifferencesOnTranslatingForeignOperationsBeforeTax",
      "label": "Exchange differences on translating foreign operations (before tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:CashFlowHedgesBeforeTax",
      "label": "Cash flow hedges (before tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:FairValueChangeOnDebtInstrumentsFVOCIBeforeTax",
      "label": "Fair value changes on debt instruments at FVOCI (before tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:ShareOfOCIOfAssociatesMayBeReclassifiedBeforeTax",
      "label": "Share of OCI of associates and joint ventures - may be reclassified (before tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:TaxRelatingToItemsMayBeReclassified",
      "label": "Tax relating to items that may be reclassified",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:TotalItemsMayBeReclassifiedNetOfTax",
      "label": "Total items may be reclassified (net of tax)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:OtherComprehensiveIncomeForTheYear",
      "label": "OTHER COMPREHENSIVE INCOME FOR THE YEAR",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:TotalComprehensiveIncomeForTheYear",
      "label": "TOTAL COMPREHENSIVE INCOME FOR THE YEAR",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "ProfitForTheYear + OtherComprehensiveIncome"
      }
    },
    {
      "qname": "ssmt:AttributionComprehensiveIncomeHeader",
      "label": "TOTAL COMPREHENSIVE INCOME ATTRIBUTABLE TO:",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt:ComprehensiveIncomeAttributableToOwnersOfParent",
      "label": "Owners of the parent",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:ComprehensiveIncomeAttributableToNonControllingInterests",
      "label": "Non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:TotalComprehensiveIncomeAttribution",
      "label": "Total",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "ComprehensiveIncomeToOwners + ComprehensiveIncomeToNCI"
      }
    }
  ]
}
